// UserProfileAddress.tsx
import React from "react";
import { User } from "../../../types/admin/UserTypes";
import { Input, Col, Typography } from "antd";

const { Text } = Typography;

interface UserProfileAddressProps {
	user: User;
	isEditing: boolean;
	setUserData: React.Dispatch<React.SetStateAction<User>>;
}

const UserProfileAddress: React.FC<UserProfileAddressProps> = ({ user, isEditing, setUserData }) => {
	const fields: { name: keyof User; label: string }[] = [
		{ name: "address", label: "Street Address" },
		{ name: "city", label: "City" },
		{ name: "state", label: "State" },
		{ name: "country", label: "Country" },
		{ name: "postal_code", label: "Postal Code" },
	];

	const handleChange = (name: keyof User, value: string) => {
		setUserData((prevUser) => ({ ...prevUser, [name]: value }));
	};

	return (
		<>
			{fields.map((field) => (
				<Col key={String(field.name)} xs={24} sm={12} md={8}>
					<Text type="secondary" style={{ fontSize: 11 }}>{field.label}</Text>
					{isEditing ? (
						<Input
							value={(user[field.name] as string) || ""}
							onChange={(e) => handleChange(field.name, e.target.value)}
							placeholder={`Enter ${field.label.toLowerCase()}`}
							style={{ marginTop: 4 }}
						/>
					) : (
						<Text style={{ fontSize: 13, display: "block", marginTop: 4 }}>{(user[field.name as keyof User] as string) || "—"}</Text>
					)}
				</Col>
			))}
		</>
	);
};

export default UserProfileAddress;
